<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'user-load-orders-program'">
  <div class="card">
    <div class="header-card separator pt-0">
      <div class="w-3 container-title">
        <span class="text-xl font-medium text-800">{{'UserPages.UserLoadOrdersProgram.PageTitle' | translate}}</span>
      </div>
      <div class="w-9 flex align-items-center justify-content-start flex-wrap">
        <span class="p-input-icon-left justify-content-start flex w-6">
          <i class="pi pi-search"></i>
          <input [(ngModel)]="searchTerm" (input)="makeFilter()" type="text" pInputText
            placeholder="{{'UserPages.UserLoadOrdersProgram.SearchProducts' | translate}}"
            class="p-inputtext-sm input-search w-full" />
        </span>
      </div>
    </div>
    <div class="body-card">
      <div class="flex flex-row justify-content-between flex-wrap align-items-center align-content-center separator">
        <div class="flex flex-row">
          <div class="container-select">
            <p-dropdown *ngIf="filterProfile"
              [options]="filterProfile"
              (onChange)="getLoadWithFilters()"
              optionLabel="companyName"
              [(ngModel)]="profileSelected"
              [showClear]="true"
              [placeholder]="profile?.type === 1 ? ('MyLoadFilter.ImporterLabel' | translate) : ('MyLoadFilter.ExporterLabel' | translate)"
              (onClear)="clearCompanyFilter()"
              [autoDisplayFirst]="false"
              class="input-load-orders-program-custom"
              styleClass="w-8rem"
            />
          </div>
          <div class="container-select">
            <p-dropdown
              [options]="years"
              [(ngModel)]="year"
              (onChange)="getLoadWithFilters()"
              placeholder="{{'MyLoadFilter.YearLabel' | translate}}"
              dropdownIcon="pi pi-calendar"
              class="input-load-orders-program-custom input-icon-calendar"
              styleClass="w-6rem"
              >
            </p-dropdown>
          </div>
          <div class="container-select" *ngIf="programs">
            <p-dropdown
              [options]="programs"
              optionLabel="name"
              optionValue="name"
              [showClear]="true"
              [(ngModel)]="programSelected"
              (onChange)="getLoads()"
              (onClear)="getLoads()"
              placeholder="{{'MyLoadFilter.ProgramLabel' | translate}}"
              class="input-load-orders-program-custom"
              styleClass="w-8rem"
            />
          </div>
          <div class="container-select" *ngIf="importOrders">
            <p-dropdown
              [options]="importOrders"
              optionLabel="name"
              optionValue="name"
              [showClear]="true"
              [(ngModel)]="importOrderSelected"
              (onChange)="getLoads()"
              (onClear)="getLoads()"
              placeholder="{{'MyLoadFilter.ImportOrderLabel' | translate}}"
              class="input-load-orders-program-custom"
              styleClass="w-8rem"
            />
          </div>
          <div class="container-select" *ngIf="orderStatus">
            <p-dropdown
              [options]="orderStatus"
              [optionLabel]="this.lang == 'es' ? 'nameEs' : 'name'"
              optionValue="value"
              [showClear]="true"
              [(ngModel)]="statusSelected"
              [autoDisplayFirst]="false"
              (onChange)="getLoads()"
              (onClear)="getLoads()"
              placeholder="{{'MyLoadFilter.StatusLabel' | translate}}"
              class="input-load-orders-program-custom"
              styleClass="w-8rem"
            />
          </div>
          <div class="container-select">
            <p-button (onClick)="onOpenAdvancedFilters()"
              styleClass="p-button" class="btn-filter btn-advanced-filter"
              label="{{'MyLoadFilter.AdvancedFiltersLabel' | translate}}" >
              <i class="material-symbols-outlined text-xl mr-2">tune</i>
            </p-button>
          </div>
        </div>

        <div class="flex flex-row align-items-center gap-2 buttons-container">
          <p-button (onClick)="goToMasterViewPage()"
            styleClass="p-button" class="btn-filter btn-view-filter"
            label="{{'UserPages.UserLoadOrdersProgram.MainTable.MasterView' | translate}}">
            <i class="material-symbols-outlined text-xl mr-1">table</i>
          </p-button>

          <p-button (onClick)="goToContainersViewPage()"
            styleClass="p-button" class="btn-filter btn-view-filter"
            label="{{'UserPages.UserLoadOrdersProgram.MainTable.ContainerView' | translate}}">
            <i class="material-symbols-outlined icon-btn-main text-base">width_normal</i>
          </p-button>

          <p-button (onClick)="goToPalletsViewPage()"
            styleClass="p-button" class="btn-filter btn-view-filter"
            label="{{'UserPages.UserLoadOrdersProgram.MainTable.PalletView' | translate}}">
            <i class="material-symbols-outlined icon-btn-main text-base">pallet</i>
          </p-button>
        </div>
      </div>

      <p-dataView
        #dataView
        [value]="formatedOrders"
        [rows]="pageSize"
        [lazy]="true"
        (onLazyLoad)="getLoadsPage($event)"
        [paginator]="true"
        [totalRecords]="totalCount"
        [loading]="loading"
        currentPageReportTemplate="{first} - {last} of {totalRecords}"
        emptyMessage="{{'UserPages.UserClosedSale.NotInformationMessageText' | translate}}"
        class="report-dataview"
      >
        <ng-template pTemplate="listItem" let-order let-rowIndex="rowIndex">
          <div class="col-12" style="margin-bottom: 20px;">
            <app-table-row-card
              [order]="order"
              [year]="year"
              [profile]="profile"
              [isProgram]="true"
              (viewPallets)="viewPallets($event)"
              (viewInstructive)="goToInstructiveViewPage($event)"
              (viewDocuments)="redirectToDocumentation($event)"
              (viewPackingList)="goToPackingListViewPage($event)"
            />
          </div>
        </ng-template>
      </p-dataView>

    </div>
  </div>
</app-user-dashboard>

<p-dialog header="Pallets" [(visible)]="showPallets" [style]="{width: '80%'}" [modal]="true">
  <div style="margin-top: 40px;">
    <p-table
      [value]="pallets"
      dataKey="dataKey"
      responsiveLayout="stack"
      [breakpoint]="'600px'"
      styleClass="p-datatable-gridlines"
      [scrollable]="true"
      [resizableColumns]="true"
      columnResizeMode="expand"
      scrollHeight="600px">
      <ng-template pTemplate="header">
        <tr>
          <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.FolioHeader' | translate}}</th>
          <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.SpeciesHeader' | translate}}</th>
          <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.VarietyHeader' | translate}}</th>
          <th *ngIf="profile?.type === 1">{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.ProducerHeader' | translate}}</th>
          <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.SpeciesSizeHeader' | translate}}</th>
          <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PackingDateHeader' | translate}}</th>
          <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.QualityControlDateHeader' | translate}}</th>
          <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PackagingHeader' | translate}}</th>
          <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletTypeHeader' | translate}}</th>
          <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.TagHeader' | translate}}</th>
          <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.BagTypeHeader' | translate}}</th>
          <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.BoxTypeHeader' | translate}}</th>
          <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.NetWeightHeader' | translate}}</th>
          <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.ColdStorageHeader' | translate}}</th>
          <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.BoxePerPalletHeader' | translate}}</th>
          <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.MarksHeader' | translate}}</th>
          <th>ETD</th>
          <th>ETA</th>
          <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.LoadWeekHeader' | translate}}</th>
          <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.OriginCountryHeader' | translate}}</th>
          <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.DestinationCountryHeader' | translate}}</th>
          <th>{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.TemptaleHeader' | translate}}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-pallet let-editing="editing" let-ri="rowIndex">
        <tr>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="pallet.palletNumber" maxlength="20" required [readOnly]="isEdit"/>
              </ng-template>
              <ng-template pTemplate="output">
                {{pallet.palletNumber}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="pallet.excelImportSpecies" maxlength="100" required/>
              </ng-template>
              <ng-template pTemplate="output">
                {{pallet.excelImportSpecies}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="pallet.excelImportVariety" maxlength="100" required/>
              </ng-template>
              <ng-template pTemplate="output">
                {{pallet.excelImportVariety}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td *ngIf="profile?.type === 1">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="pallet.producer" maxlength="200" required/>
              </ng-template>
              <ng-template pTemplate="output">
                {{pallet.producer}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="pallet.speciesSize" maxlength="30"/>
              </ng-template>
              <ng-template pTemplate="output">
                {{pallet.speciesSize}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="pallet.excelImportHarvestDate" maxlength="50"/>
              </ng-template>
              <ng-template pTemplate="output">
                {{pallet.excelImportHarvestDate}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="pallet.excelImportQualityControlDate" maxlength="50"/>
              </ng-template>
              <ng-template pTemplate="output">
                {{pallet.excelImportQualityControlDate}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="pallet.excelImportPackaging" maxlength="50"/>
              </ng-template>
              <ng-template pTemplate="output">
                {{pallet.excelImportPackaging}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="pallet.excelImportPalletType" maxlength="50"/>
              </ng-template>
              <ng-template pTemplate="output">
                {{pallet.excelImportPalletType}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="pallet.excelImportTag" maxlength="50"/>
              </ng-template>
              <ng-template pTemplate="output">
                {{pallet.excelImportTag}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="pallet.excelImportBagType" maxlength="50"/>
              </ng-template>
              <ng-template pTemplate="output">
                {{pallet.excelImportBagType}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="pallet.excelImportBoxSize" maxlength="50"/>
              </ng-template>
              <ng-template pTemplate="output">
                {{pallet.excelImportBoxSize}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="pallet.excelImportNetWeight" maxlength="50"/>
              </ng-template>
              <ng-template pTemplate="output">
                {{pallet.excelImportNetWeight}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="pallet.excelImportFridgeStorage" maxlength="50"/>
              </ng-template>
              <ng-template pTemplate="output">
                {{pallet.excelImportFridgeStorage}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="pallet.excelImportBoxesPerPallet" maxlength="50"/>
              </ng-template>
              <ng-template pTemplate="output">
                {{pallet.excelImportBoxesPerPallet}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="pallet.excelImportMark" maxlength="50"/>
              </ng-template>
              <ng-template pTemplate="output">
                {{pallet.excelImportMark}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>{{ orderDetailInformation?.etd ? (orderDetailInformation?.etd | date:'dd-MM-yyyy') : '(Pending)' }}</td>
          <td>{{ orderDetailInformation?.eta ? (orderDetailInformation?.eta | date:'dd-MM-yyyy') : '(Pending)'}}</td>
          <td>{{ orderDetailInformation?.week ? orderDetailInformation?.week : '(Pending)'}}</td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="pallet.excelImportOriginCountry" maxlength="50"/>
              </ng-template>
              <ng-template pTemplate="output">
                {{pallet.excelImportOriginCountry}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>{{ orderDetailInformation?.destinationPortName ? orderDetailInformation?.destinationPortName : '(Pending)'}}</td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="pallet.excelImportTemptale" maxlength="50"/>
              </ng-template>
              <ng-template pTemplate="output">
                {{pallet.excelImportTemptale}}
              </ng-template>
            </p-cellEditor>
          </td>
        </tr>

      </ng-template>

    </p-table>

  </div>
</p-dialog>

<p-sidebar [(visible)]="showAdvancedFilters" position="right" class="advanced-form-sidebar">
  <ng-template pTemplate="header">
    <p class="my-0 font-medium text-lg">{{'MyLoadFilter.AdvancedFiltersTitle' | translate}}</p>
  </ng-template>

  <div class="flex flex-column justify-content-center p-2 gap-3 mt-3">
    <form [formGroup]="advancedFilterForm" class="flex flex-column justify-content-center gap-3">
      <p-dropdown
        [options]="filterProfile"
        optionLabel="companyName"
        optionValue="id"
        formControlName="clientId"
        [showClear]="true"
        [placeholder]="profile?.type === 1 ? ('MyLoadFilter.ImporterLabel' | translate) : ('MyLoadFilter.ExporterLabel' | translate)"
        [autoDisplayFirst]="false"
        class="input-load-orders-program-custom"
        styleClass="w-full"
      />

      <p-dropdown
        [options]="years"
        formControlName="year"
        placeholder="{{'MyLoadFilter.YearLabel' | translate}}"
        dropdownIcon="pi pi-calendar"
        class="input-load-orders-program-custom input-icon-calendar"
        styleClass="w-full"
      />

      <p-dropdown
        [options]="programs"
        formControlName="programId"
        optionLabel="name"
        optionValue="name"
        [showClear]="true"
        placeholder="{{'MyLoadFilter.ProgramLabel' | translate}}"
        class="input-load-orders-program-custom"
        styleClass="w-full"
      />

      <p-dropdown
        [options]="importOrders"
        formControlName="importOrder"
        optionLabel="name"
        optionValue="name"
        [showClear]="true"
        placeholder="{{'MyLoadFilter.ImportOrderLabel' | translate}}"
        class="input-load-orders-program-custom"
        styleClass="w-full"
      />

      <p-dropdown
        [options]="orderStatus"
        formControlName="status"
        [optionLabel]="this.lang == 'es' ? 'nameEs' : 'name'"
        optionValue="value"
        [showClear]="true"
        [autoDisplayFirst]="false"
        placeholder="{{'MyLoadFilter.StatusLabel' | translate}}"
        class="input-load-orders-program-custom"
        styleClass="w-full"
      />

      <p-dropdown
        placeholder="{{'MyLoadFilter.Species' | translate}}"
        [options]="species"
        [optionLabel]="this.lang == 'es' ? 'nameEs' : 'name'"
        formControlName="speciesId"
        optionValue="id"
        (onChange)="loadVarieties()"
        [filter]="true"
        [filterBy]="this.lang == 'es' ? 'nameEs' : 'name'"
        [showClear]="true"
        [autoDisplayFirst]="false"
        class="input-load-orders-program-custom"
        styleClass="w-full"
      />

      <p-dropdown
        placeholder="{{'MyLoadFilter.Variety' | translate}}"
        optionLabel="name"
        optionValue="id"
        formControlName="varietyId"
        [options]="varieties"
        [filter]="true"
        [showClear]="true"
        filterBy="name"
        class="input-load-orders-program-custom"
        styleClass="w-full"
      />

      <p-dropdown
        placeholder="{{'MyLoadFilter.TransportTypeLabel' | translate}}"
        [options]="transportSelect"
        [optionLabel]="this.lang == 'es' ? 'nameEs' : 'nameEn'"
        optionValue="value"
        formControlName="transportType"
        [autoDisplayFirst]="false"
        class="input-load-orders-program-custom"
        styleClass="w-full"
      />

      <p-dropdown
        [options]="naveSelect"
        optionLabel="value"
        formControlName="naveId"
        optionValue="value"
        [filter]="true"
        filterBy="value"
        [showClear]="true"
        [autoDisplayFirst]="false"
        placeholder="{{'MyLoadFilter.Nave' | translate}}"
        class="input-load-orders-program-custom"
        styleClass="w-full"
      />

      <p-dropdown
        [options]="departurePortSelect"
        optionLabel="label"
        formControlName="departurePortId"
        optionValue="value"
        [filter]="true"
        filterBy="label"
        [showClear]="true"
        [autoDisplayFirst]="false"
        placeholder="{{'MyLoadFilter.DeparturePort' | translate}}"
        class="input-load-orders-program-custom"
        styleClass="w-full"
      />

      <p-dropdown
        [options]="destinationPortSelect"
        optionLabel="label"
        formControlName="destinationPortId"
        optionValue="value"
        [filter]="true"
        filterBy="label"
        [showClear]="true"
        [autoDisplayFirst]="false"
        placeholder="{{'MyLoadFilter.DestinationPort' | translate}}"
        class="input-load-orders-program-custom"
        styleClass="w-full"
      />

      <div class="flex flex-row justify-content-between mt-4">
        <div class="flex">
          <p-button (onClick)="onClearFilters()" label="{{'MyLoadFilter.CleanFilters' | translate}}"
            styleClass="p-button-outlined px-3" class="btn-filter text-sm">
          </p-button>
        </div>

        <div class="flex">
          <p-button (onClick)="onApplyFilters()" label="{{'MyLoadFilter.ApplyFilters' | translate}}"
            styleClass="p-button" class="btn-filter text-sm">
            <span class="material-symbols-outlined mr-1 text-base">tune</span>
          </p-button>
        </div>
      </div>
    </form>
  </div>
</p-sidebar>
